// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Parallelogram.View'
    , [
        'calculator_square_foot_parallelogram.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_parallelogram_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_parallelogram_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-parallelogram"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var base = $('#square-foot-parallelogram-base').val(),
                    height = $('#square-foot-parallelogram-height').val();
                //output fields
                var area = $('#square-foot-parallelogram-area');

                var result = parseFloat(base) * parseFloat(height);

                area.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-parallelogram-input-fields').find('input:text').val('');
                $('.calculator-square-foot-parallelogram-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
